import { initializeApp } from 'firebase/app';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyD7BYUNNIAAHn9delek9FogEYNMQgCLa1c',
  authDomain: 'iwebwiserhrm.firebaseapp.com',
  projectId: 'iwebwiserhrm',
  storageBucket: 'iwebwiserhrm.firebasestorage.app',
  messagingSenderId: '173287653692',
  appId: '1:173287653692:web:9cc30a7a5a93be0cfade39',
  measurementId: 'G-XXYSEZXSGY',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export { app };
